import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex } from '@woovi/ui';
import { maskMoney } from '@woovi/utils';

import type { PaymentActiveCustomerPixCreditCard_charge$key } from './__generated__/PaymentActiveCustomerPixCreditCard_charge.graphql.ts';

import type { ReactNode } from 'react';

type PaymentActiveCustomerPixCreditCardProps = {
  charge: PaymentActiveCustomerPixCreditCard_charge$key;
};
const PaymentActiveCustomerPixCreditCard = (
  props: PaymentActiveCustomerPixCreditCardProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentActiveCustomerPixCreditCard_charge$key>(
    graphql`
      fragment PaymentActiveCustomerPixCreditCard_charge on Charge {
        customer {
          name
        }
        value
        valueWithDiscount
        type
      }
    `,
    props.charge,
  );

  const value = charge.value ?? charge.valueWithDiscount;

  return (
    <BoxFlex sx={{ justifyContent: 'center' }}>
      <Typography
        sx={{ fontSize: 24, fontWeight: 'bold', textAlign: 'center' }}
      >
        {charge.customer
          ? t('{{customerName}}, how do you want to pay {{value}}?', {
              customerName: charge.customer.name,
              value: maskMoney(value / 100),
            })
          : t('How do you want to pay {{value}}?', {
              value: maskMoney(value / 100),
            })}
      </Typography>
    </BoxFlex>
  );
};

export default PaymentActiveCustomerPixCreditCard;
